/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { ReactComponent as WebIcon } from '../../../../assets/svg/company-icon/web.svg';

const CompanyWebsite = props => {
  const { primaryDomain = '', parentClass = '', clsName = '' } = props;

  return primaryDomain !== undefined &&
    primaryDomain !== '' &&
    primaryDomain !== null ? (
    <div className={`company-website icon-wrap ${parentClass}`}>
      <a
        href={`https://www.${primaryDomain}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <WebIcon className="svg-icon" />
        <div className={`item-name show-elipsis ${clsName}`}>
          {primaryDomain}
        </div>
      </a>
    </div>
  ) : (
    ''
  );
};

export { CompanyWebsite };
export default CompanyWebsite;
